import React,{useEffect,useState} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Loader from './commonComponents/Loader';

const ProtectedRoute = ({ component: Component,...rest }) => {
  const TOKEN_EXPIRY_HOURS = 24; 
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
    const msisdn = reactLocalStorage.get("msisdn");
    const userStatus = reactLocalStorage.get("status");
    const storedTime = reactLocalStorage.get("lastCheckSubTime") || 0;
    const currentTime = new Date().getTime();
    const expiryTime = TOKEN_EXPIRY_HOURS * 60 * 60 * 1000;
   
   useEffect(()=>
  {
    if (storedTime && (currentTime - storedTime) < expiryTime && msisdn && userStatus === "active") {
      setIsAuthenticated(true);
      setLoading(false);
    } else {
      setIsAuthenticated(false);
      setLoading(false);
    }
  },[currentTime,storedTime]);

if(loading) return <Loader/>;
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isAuthenticated ? 
            <Component {...routeProps} /> 
         : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default ProtectedRoute;